import React from "react";

import PrivacyPolicyLayout from "./PrivacyPolicyLayout";

const TermsAndConditions = () => {
  return (
    <PrivacyPolicyLayout>
      <h1>TERMS &amp; CONDITIONS</h1>
      <h2>ACCEPTANCE OF TERMS</h2>
      <p>
        By creating a Maidaan account, you’re agreeing to these terms as well as
        any additional terms of use by our partners.
      </p>
      <p>
        The Service is offered subject to acceptance without modification of all
        of the terms and conditions contained herein and all other operating
        rules, policies and procedures that may be published from time to time
        on the Mobile applications and Sites by Maidaan. In addition, some
        services offered through the Service may be subject to additional terms
        and conditions promulgated by Maidaan from time to time; your use of
        such services is subject to those additional terms and conditions, which
        are incorporated into these Terms of Use by this reference. You
        represent and warrant that if you are an individual, you are of legal
        age to agree to these terms and conditions or you have your parents’
        permission to do so, and that all registration information you submit
        (including any details you submit for a parent or guardian) is accurate
        and truthful. Maidaan may, in its sole discretion, refuse to offer the
        Service to any person or entity and change its eligibility criteria at
        any time. This provision is void where prohibited by law and the right
        to access the Service is revoked in such jurisdictions.
      </p>
<br />
      <h2>GENERAL CONDITIONS</h2>
      <p>
        We reserve the right to refuse service to anyone for any reason at any
        time. You understand that your content (not including credit card
        information), may be transferred unencrypted and involve (a)
        transmissions over various networks; and (b) changes to conform and
        adapt to technical requirements of connecting networks or devices.
        Credit card information is always encrypted during transfer over
        networks. You agree not to reproduce, duplicate, copy, sell, resell or
        exploit any portion of the Service, use of the Service, or access to the
        Service or any contact on the website through which the service is
        provided, without express written permission by us. The headings used in
        this agreement are included for convenience only and will not limit or
        otherwise affect these Terms.
      </p>
      <br />
      <h2>RULES AND CONDUCT</h2>
      <p>
        This section lists stuff you know you shouldn’t do: breaking laws,
        stealing data, abusing other members, etc. Just be nice - to us and to
        other members. Maidaan is a positive and safe place. Let’s keep it that
        way.
      </p>
      <p>
        As a condition of use, you promise not to use the Service for any
        purpose that is prohibited by the Terms of Use. The Service (including,
        without limitation, any Content, or User Submissions (both as defined
        below)) is provided only for your own personal, non-commercial use. You
        are responsible for all of your activity in connection with the Service.
        For purposes of the Terms of Use, the term “Content” includes, without
        limitation, any advertisements, advice, suggestions, videos, audio
        clips, written forum comments, information, data, text, photographs,
        software, scripts, graphics, and interactive features generated,
        provided, or otherwise made accessible by Maidaan or its partners on or
        through the Service.
      </p>
      <p>
        By way of example, and not as a limitation, you shall not (and shall not
        permit any third party to) either (a) take any action or (b) upload,
        download, post, submit or otherwise distribute or facilitate
        distribution of any content on or through the Service, that:
      </p>
      <ul>
        <li>
          infringes any patent, trademark, trade secret, copyright, right of
          publicity or other right of any other person or entity;
        </li>
        <li>
          is unlawful, threatening, abusive, harassing, defamatory, libelous,
          deceptive, fraudulent, invasive of another’s privacy, tortious,
          obscene, offensive, or profane;
        </li>
        <li>
          constitutes unauthorized or unsolicited advertising, junk, spam or
          bulk e-mail (including without limitation any postings to third party
          social media sites which are linked to the Site or the Service);
        </li>
        <li>
          involves commercial activities and/or sales without Maidaan’s prior
          written consent;
        </li>
        <li>
          contains software viruses or any other computer codes, files, or
          programs that are designed or intended to disrupt, damage, limit or
          interfere with the proper function of any software, hardware, or
          telecommunications equipment or to damage or obtain unauthorized
          access to any system, data, password or other information of Maidaan
          or any third party; or
        </li>
        <li>
          impersonates any person or entity, including any employee or
          representative of Maidaan.
        </li>
      </ul>
      <p>Additionally, you shall not:</p>
      <ul>
        <li>
          (i) take any action that imposes or may impose (as determined by
          Maidaan in its sole discretion) an unreasonable or disproportionately
          large load on Maidaan’s (or its third party providers’)
          infrastructure;
        </li>
        <li>
          (ii) interfere or attempt to interfere with the proper working of the
          Service or any activities conducted on the Service;
        </li>
        <li>
          (iii) bypass any measures Maidaan may use to prevent or restrict
          access to the Service (or other accounts, computer systems or networks
          connected to the Service); or
        </li>
        <li>
          (iv) use manual or automated software, devices, or other processes to
          “crawl” or “spider” any page of the Sites.
        </li>
      </ul>
      <p>You shall not (directly or indirectly):</p>
      <ul>
        <li>
          (i) decipher, decompile, disassemble, reverse engineer or otherwise
          attempt to derive any source code or underlying ideas or algorithms of
          any part of the Service, except (A) for any part of the Service which
          is licensed under an open source or similar license or (B) to the
          limited extent applicable laws specifically prohibit such restriction;
        </li>
        <li>
          (ii) modify, translate, or otherwise create derivative works of any
          part of the Service except where license permits; or
        </li>
        <li>
          (iii) copy, rent, lease, distribute, or otherwise transfer any or all
          of the rights that you receive hereunder.
        </li>
      </ul>
      <p>
        You shall abide by all applicable local, state, national and
        international laws and regulations.
      </p>
      <p>
        Maidaan reserves the right to remove any Content from the Sites or
        Service at any time, for any reason (including, but not limited to, upon
        receipt of claims or allegations from third parties or authorities
        relating to such Content or if Maidaan is concerned that you may have
        violated the Terms of Use), or for no reason at all.
      </p>
      <br />
      <h2>REGISTRATION</h2>
      <p>
        When signing up for Maidaan, you need to be honest about who you are.
        You are responsible for your account and any material/activity on it.
      </p>
      <p>
        You shall not (i) impersonate any other person; (ii) use a name that is
        otherwise offensive, vulgar or obscene.
      </p>
      <p>
        Maidaan reserves the right to refuse registration of, or cancel a
        Maidaan User ID in its sole discretion. You are solely responsible for
        activity that occurs on your account and shall be responsible for
        maintaining the confidentiality of your account. You shall never use
        another user’s account without such other user’s express permission. You
        will immediately notify Maidaan in writing of any unauthorised use of
        your account, or other account related security breach of which you are
        aware.
      </p>
      <br />
      <h2>SITE CONTENT</h2>
      <p>
        The content here is protected - you can use it for personal reasons, but
        you can’t use it commercially without getting permission from us first.
      </p>
      <br />
      <h2>GENERAL CONTENT DISCLAIMER</h2>
      <p>
        Maidaan makes no representations or warranties concerning the
        appropriateness, accuracy, reliability, usefulness, completeness, or
        timeliness of any Content, and you should not rely on the Content for
        any purpose. No Content is intended to substitute for personal advice
        from a qualified professional. When applicable, always seek the advice
        of a qualified professional, and never disregard professional advice or
        delay in seeking it because of any Content.
      </p>
      <br />
      <h2>CHANGES TO TERMS OF SERVICE</h2>
      <p>
        You can review the most current version of the Terms of Service at any
        time at this page. We reserve the right, at our sole discretion, to
        update, change or replace any part of these Terms of Service by posting
        updates and changes to our website. It is your responsibility to check
        our website periodically for changes. Your continued use of or access to
        our website or the Service following the posting of any changes to these
        Terms of Service constitutes acceptance of those changes.
      </p>
    </PrivacyPolicyLayout>
  );
};

export default TermsAndConditions;
